import { ITurnedTextStyle } from "./ITurnedTextStyle";

export interface ITurnedTextStyleSpecifiable {
  turnedTextStyle: ITurnedTextStyle;
}

export function instanceOfITurnedTextStyleSpecifiable(instance: any): instance is ITurnedTextStyleSpecifiable {
  return instance
      && (instance.turnedTextStyle !== undefined);
}
